import { ArrowRightLeft, Copy } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { MigrationMode } from '../types';

interface ModeSelectorProps {
  selectedMode: MigrationMode;
  onSelectMode: (mode: MigrationMode) => void;
}

export function ModeSelector({ selectedMode, onSelectMode }: ModeSelectorProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Migration Mode</CardTitle>
      </CardHeader>
      <CardContent>
        <div role="radiogroup" aria-label="Migration mode" className="grid grid-cols-2 gap-4">
          {/* Move card */}
          <button
            type="button"
            role="radio"
            aria-checked={selectedMode === 'move'}
            onClick={() => onSelectMode('move')}
            className={cn(
              'rounded-lg border-2 p-4 text-left transition-colors',
              selectedMode === 'move'
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-primary/50',
            )}
          >
            <div className="flex items-center gap-2 mb-2">
              <ArrowRightLeft className="h-5 w-5 text-primary" />
              <span className="font-semibold">Move</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Transfer all assets from source to target account.
            </p>
          </button>

          {/* Copy card */}
          <button
            type="button"
            role="radio"
            aria-checked={selectedMode === 'copy'}
            onClick={() => onSelectMode('copy')}
            className={cn(
              'rounded-lg border-2 p-4 text-left transition-colors',
              selectedMode === 'copy'
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-primary/50',
            )}
          >
            <div className="flex items-center gap-2 mb-2">
              <Copy className="h-5 w-5 text-primary" />
              <span className="font-semibold">Copy</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Duplicate structural assets to target, source stays unchanged.
            </p>
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
